import { PortalCard, Skeleton, SkeletonGroup } from '../../portal';
import {
  LatestReviewsCardFrame,
  LatestReviewsSkeleton,
} from './LatestReviewsCard';
import { OverviewStats } from './OverviewStats';

/**
 * Skeletons for the Overview page. Every block mirrors the final element's
 * box 1:1 (same containers, gaps and line heights) so nothing shifts when the
 * data lands.
 */

/** One summary column: 16px label / 40px value row (+ pill) / 16px caption. */
export function OverviewSummaryColumnSkeleton() {
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <Skeleton className="h-4 w-20" />
      <div className="flex h-10 items-center gap-3">
        <Skeleton className="h-10 w-28" />
        <Skeleton className="h-5 w-16" rounded="full" />
      </div>
      <Skeleton className="h-4 w-32" />
    </div>
  );
}

/** Same card and grid as `OverviewSummaryCard`. */
export function OverviewSummaryCardSkeleton() {
  return (
    <PortalCard className="grid gap-8 px-6 py-8 md:grid-cols-3 lg:px-[74px] lg:py-10">
      <OverviewSummaryColumnSkeleton />
      <OverviewSummaryColumnSkeleton />
      <OverviewSummaryColumnSkeleton />
    </PortalCard>
  );
}

/** Whole page before the dapp has loaded: header, summary, stats, reviews. */
export function OverviewSkeleton() {
  return (
    <SkeletonGroup label="Loading overview" className="flex flex-col gap-10">
      <header className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex min-w-0 flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6">
          <Skeleton className="size-24 shrink-0 rounded-[22%]" />
          <div className="flex min-w-0 flex-col gap-2">
            <div className="flex h-10 items-center gap-3">
              <Skeleton className="h-10 w-48" />
              <Skeleton className="h-6 w-16" rounded="full" />
            </div>
            <span className="flex h-5 items-center">
              <Skeleton className="h-3.5 w-40" />
            </span>
          </div>
        </div>
      </header>
      <OverviewSummaryCardSkeleton />
      <OverviewStats
        analytics={null}
        totalReviews={null}
        reviewsThisWeek={null}
        isLoading
      />
      <LatestReviewsCardFrame>
        <LatestReviewsSkeleton />
      </LatestReviewsCardFrame>
    </SkeletonGroup>
  );
}
